import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { AInvoiceCreditNoteSliceState } from "../../utils/invoice.types";
import { ApiStatus } from "../../utils/api.types";
import { addInvoiceCreditNote, deleteInvoice, fetchCreditNotes, updateInvoiceCreditNote, fetchInvoiceCreditNoteById, dispatchInvoiceCreditNote, manualPayment, shareInvoicePaymentReceipt, fetchInvoicesWithoutState } from "./creditNoteThunk";

/**
 * Invoice slice initial state.
 */
const initialState: AInvoiceCreditNoteSliceState = {
    creditNotes: [],
    creditNoteDetails: {},
    errorMessage: '',
    isCreditNoteCreated: false,
    selectedCreditNoteId: '',
    status: ApiStatus.IDLE
}

/**
 * Invoice Slice.
 */
const creditNoteSlice = createSlice({
    name: 'creditNote',
    initialState: initialState,
    reducers: {
        // Selected Invoice id
        //selectedInvoiceId: (state, action) => {
        // state.selectedInvoiceId = action.payload || '';
        // }
    },
    extraReducers: (builder) => {
        builder
            // Fetch Invoices
            .addCase(fetchCreditNotes.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchCreditNotes.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.creditNotes = action?.payload.invoices || [];
                state.creditNoteDetails = {};
                state.errorMessage = '';
            })

            .addCase(fetchCreditNotes.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Fetch Invoice by ID
            .addCase(fetchInvoiceCreditNoteById.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchInvoiceCreditNoteById.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.creditNoteDetails = action.payload || [];
                state.errorMessage = '';
            })
            .addCase(fetchInvoiceCreditNoteById.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Add Invoice
            .addCase(addInvoiceCreditNote.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(addInvoiceCreditNote.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.isCreditNoteCreated = true;
                state.creditNotes.push(action.payload);
                state.errorMessage = '';

                toast.success(action.payload.message);
            })
            .addCase(addInvoiceCreditNote.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.isCreditNoteCreated = false;
                state.errorMessage = action.error.message
            })

            // Delete Invoice
            .addCase(deleteInvoice.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(deleteInvoice.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                state.errorMessage = '';

                const { id, message } = action.payload;
                state.creditNotes = state.creditNotes.filter(item => item._id !== id)

                toast.success(message);
            })
            .addCase(deleteInvoice.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message

                toast.success(state.errorMessage);
            })

            // Update Invoice
            .addCase(updateInvoiceCreditNote.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(updateInvoiceCreditNote.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                const { message, invoice: updateInvoice } = action.payload
                state.creditNotes = state.creditNotes
                    .map(item => (item._id === item._id ? { ...item, ...updateInvoice } : item));

                state.errorMessage = '';

                toast.success(message);
            })
            .addCase(updateInvoiceCreditNote.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
            })
            // Dispatch Invoice
            .addCase(dispatchInvoiceCreditNote.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(dispatchInvoiceCreditNote.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                state.errorMessage = '';
                const { message } = action.payload;
                toast.success(message);
            })
            .addCase(dispatchInvoiceCreditNote.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
                toast.success(state.errorMessage);
            })
            .addCase(manualPayment.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(manualPayment.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                state.errorMessage = '';
                const { message } = action.payload;
                toast.success(message);
            })
            .addCase(manualPayment.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
                toast.success(state.errorMessage);
            })
            //  Share Invoice Payment Receipt
            .addCase(shareInvoicePaymentReceipt.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(shareInvoicePaymentReceipt.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                state.errorMessage = '';
                const { message } = action.payload;
                toast.success(message);
            })
            .addCase(shareInvoicePaymentReceipt.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
                toast.error(state.errorMessage);
            })
            // Fetch invoice without saving to state
            .addCase(fetchInvoicesWithoutState.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchInvoicesWithoutState.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.errorMessage = '';
                const { message } = action.payload;
                toast.success(message);
            })
            .addCase(fetchInvoicesWithoutState.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
                toast.error(state.errorMessage);
            })

            
    }
});

export default creditNoteSlice.reducer;
